module.exports = __webpack_public_path__ + "img/185.5566f8c9.jpg";